<template>
  <el-dialog
    :title="productId === '110' ? $t('text.batchCollection') : $t('text.batchDisbursement')"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
    width="600px"
  >
    <!-- 代收   -->
    <el-form :model="form" :rules="rules" ref="form" v-if="productId === '110'">
      <el-form-item
        v-if="ROLE_TYPE.isManager()"
        :label="$t('text.collectionChannel')"
        prop="channelId"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="form.channelId"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
            v-for="item in channelList"
            :key="item.channelId"
            :label="item.channelName"
            :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionJCChannel')"
          :label-width="formLabelWidth"
          prop="paymentJazzcashChannelId"
      ><el-input
          v-model="form.paymentJazzcashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionJCQrChannel')"
          :label-width="formLabelWidth"
          prop="paymentJazzcashQrChannelId"
      ><el-input
          v-model="form.paymentJazzcashQrChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionBkJCChannel')"
          :label-width="formLabelWidth"
          prop="paymentBackupJazzcashChannelId"
      ><el-input
          v-model="form.paymentBackupJazzcashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionEPChannel')"
          :label-width="formLabelWidth"
          prop="paymentEasypaisaChannelId"
      ><el-input
          v-model="form.paymentEasypaisaChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionEPQrChannel')"
          :label-width="formLabelWidth"
          prop="paymentEasypaisaQrChannelId"
      ><el-input
          v-model="form.paymentEasypaisaQrChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionBkEPChannel')"
          :label-width="formLabelWidth"
          prop="paymentBackupEasypaisaChannelId"
      ><el-input
          v-model="form.paymentBackupEasypaisaChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionCardChannel')"
          :label-width="formLabelWidth"
          prop="paymentCardChannelId"
      ><el-input
          v-model="form.paymentCardChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.collectionBillChannel')"
          :label-width="formLabelWidth"
          prop="paymentBillChannelId"
      ><el-input
          v-model="form.paymentBillChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>
    <!-- 代付   -->
    <el-form :model="form" :rules="rules" ref="form" v-if="productId === '120'">
      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementChannel')"
          prop="withdrawChannelId"
          :label-width="formLabelWidth"
      >
        <el-select
            v-model="form.withdrawChannelId"
            filterable
            :placeholder="$t('message.chooseOne')"
            :disabled="ROLE_TYPE.isAgent()"
        >
          <el-option
              v-for="item in channelList"
              :key="item.channelId"
              :label="item.channelName"
              :value="item.channelId"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementJCChannel')"
          :label-width="formLabelWidth"
          prop="transferJazzcashChannelId"
      ><el-input
          v-model="form.transferJazzcashChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementEPChannel')"
          :label-width="formLabelWidth"
          prop="transferEasypaisaChannelId"
      ><el-input
          v-model="form.transferEasypaisaChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>

      <el-form-item
          v-if="ROLE_TYPE.isManager()"
          :label="$t('text.disbursementBankChannel')"
          :label-width="formLabelWidth"
          prop="transferBankChannelId"
      ><el-input
          v-model="form.transferBankChannelId"
          :placeholder="$t('message.inputChannelId')"
      ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="isButton"
        >{{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  name: "channelEdit",
  props: {
    show: Boolean,
    value: Array,
    action: String
  },
  data() {
    return {
      dialogShow: this.show,
      isButton: true,
      isDisabled: false,
      channelList: [],
      form: {
        productId: "",
        channelId: "",
        paymentJazzcashChannelId: "",
        paymentJazzcashQrChannelId: "",
        paymentEasypaisaChannelId: "",
        paymentEasypaisaQrChannelId: "",
        paymentCardChannelId: "",
        withdrawChannelId: "",
        transferJazzcashChannelId: "",
        transferEasypaisaChannelId: "",
        transferBankChannelId: "",
      },
      formLabelWidth: "120px",
      rules: {
        channelId: [{ required: true, message: this.$t('message.channelIdRequiredError'), trigger: ["blur", "change"] }],
        withdrawChannelId: [{ required: true, message: this.$t('message.channelIdRequiredError'), trigger: ["blur", "change"] }]
      }
    };
  },
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    },
    productId() {
      return this.action.replace("batch_", "");
    }
  },
  watch: {
    action() {
      this.getChannelList(this.productId);
    }
  },
  methods: {
    init() {},
    closeDialog() {
      this.form = {
        channelId: "",
        paymentJazzcashChannelId: "",
        paymentJazzcashQrChannelId: "",
        paymentEasypaisaChannelId: "",
        paymentEasypaisaQrChannelId: "",
        paymentCardChannelId: "",
        withdrawChannelId: "",
        transferJazzcashChannelId: "",
        transferEasypaisaChannelId: "",
        transferBankChannelId: "",
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    getChannelList(productId) {
      this.axios
        .get("/routeConfigInfo/selectChannelList", {
          params: {
            productId
          }
        })
        .then((res) => {
          if (res.code === 200) {
            this.channelList = res.data;
          }
        });
    },
    buildBatchParams(forceUpdate) {
      const paymentChannelConfig = {};
      if (this.form.paymentJazzcashChannelId) paymentChannelConfig.jazzcash = this.form.paymentJazzcashChannelId;
      if (this.form.paymentJazzcashQrChannelId) paymentChannelConfig.jazzcashQr = this.form.paymentJazzcashQrChannelId;
      if (this.form.paymentBackupJazzcashChannelId) paymentChannelConfig.jazzcashBackup = this.form.paymentBackupJazzcashChannelId;
      if (this.form.paymentEasypaisaChannelId) paymentChannelConfig.easypaisa = this.form.paymentEasypaisaChannelId;
      if (this.form.paymentEasypaisaQrChannelId) paymentChannelConfig.easypaisaQr = this.form.paymentEasypaisaQrChannelId;
      if (this.form.paymentBackupEasypaisaChannelId) paymentChannelConfig.easypaisaBackup = this.form.paymentBackupEasypaisaChannelId;
      if (this.form.paymentCardChannelId) paymentChannelConfig.card = this.form.paymentCardChannelId;
      if (this.form.paymentBillChannelId) paymentChannelConfig.bill = this.form.paymentBillChannelId;

      const transferChannelConfig = {};
      if (this.form.transferJazzcashChannelId) transferChannelConfig.jazzcash = this.form.transferJazzcashChannelId;
      if (this.form.transferEasypaisaChannelId) transferChannelConfig.easypaisa = this.form.transferEasypaisaChannelId;
      if (this.form.transferBankChannelId) transferChannelConfig.card = this.form.transferBankChannelId;

      return {
        ...this.form,
        paymentChannelConfig: Object.keys(paymentChannelConfig).length > 0 ? JSON.stringify(paymentChannelConfig) : '',
        transferChannelConfig: Object.keys(transferChannelConfig).length > 0 ? JSON.stringify(transferChannelConfig) : '',
        routeIds: this.value.join(","),
        productId: this.productId,
        forceUpdate: !!forceUpdate
      };
    },
    submit() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = this.buildBatchParams(false);

          this.axios
            .post("/routeConfigInfo/routeConfigInfoUpdateBatch", params)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });

                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
              } else if ((res.msg || '').includes('通道成本')) {
                const warningMessage = (res.msg || '').replace(/；/g, '<br/>');
                this.$confirm(
                    `<div style="line-height: 1.6; margin-bottom: 12px;">${warningMessage}</div><div>${this.$t('message.confirmForceOperate')}</div>`,
                    this.$t('text.prompt'),
                    {
                      confirmButtonText: this.$t('text.confirm'),
                      cancelButtonText: this.$t('text.cancel'),
                      type: 'warning',
                      dangerouslyUseHTMLString: true,
                    })
                    .then(() => {
                      this.axios.post("/routeConfigInfo/routeConfigInfoUpdateBatch", this.buildBatchParams(true)).then((forceRes) => {
                        if (forceRes.code === 200) {
                          this.$notify({
                            title: this.$t('text.prompt'),
                            message: forceRes.msg,
                            type: "success"
                          });
                          this.$bus.$emit("refresh");
                          this.closeDialog();
                        } else {
                          this.$notify.error({
                            title: this.$t('text.prompt'),
                            message: forceRes.msg
                          });
                        }
                      });
                    })
                    .catch(() => {});
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
